define('constants/storageConfigStatus',[],function () {
    'use strict';

    return {
        revoked: 'REVOKED',
        active: 'ACTIVE'
    };
});
